export default __webpack_public_path__ + "static/media/016-police-badge.59184e11.png";